import {
  SnippetElement,
  defineElement,
  globalOn,
  liquidValue,
  onClick,
  param,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/pb-common-product-slider/pb-common-product-slider.ts
var PbCommonProductSlider = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.slidesMap = /* @__PURE__ */ new Map();
  }
  init() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      if (!this.mainSwiper.swiperInstance)
        return;
      (_a = this.querySelector(`[data-bullet="${this.mainSwiper.swiperInstance.realIndex}"]`)) == null ? void 0 : _a.setAttribute("data-active", "true");
      (_b = this.querySelector(`[data-gray-bullet="${this.mainSwiper.swiperInstance.realIndex}"]`)) == null ? void 0 : _b.setAttribute("data-gray-active", "true");
      this.mainSwiper.swiperInstance.on("slideChange", () => {
        this.updateBullets();
      });
      (_c = this.slides) == null ? void 0 : _c.forEach((slide) => {
        var _a2, _b2;
        (_b2 = this.slidesMap) == null ? void 0 : _b2.set(parseInt((_a2 = slide.dataset.mediaId) != null ? _a2 : "0"), slide.cloneNode(true));
      });
    });
  }
  updateBullets() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    this.querySelectorAll("[data-bullet]").forEach((bullet) => {
      bullet.removeAttribute("data-active");
    });
    const activeBullet = (_c = this.bullets) == null ? void 0 : _c.filter((elm) => elm.style.display !== "none")[(_b = (_a = this.mainSwiper.swiperInstance) == null ? void 0 : _a.realIndex) != null ? _b : 0];
    activeBullet == null ? void 0 : activeBullet.setAttribute("data-active", "");
    this.querySelectorAll("[data-gray-bullet]").forEach((bullet) => {
      bullet.removeAttribute("data-gray-active");
    });
    const activeGrayBullet = (_f = this.grayBullets) == null ? void 0 : _f.filter((elm) => elm.style.display !== "none")[(_e = (_d = this.mainSwiper.swiperInstance) == null ? void 0 : _d.realIndex) != null ? _e : 0];
    activeGrayBullet == null ? void 0 : activeGrayBullet.setAttribute("data-gray-active", "");
    (_i = this.thumbnailSwiper.swiperInstance) == null ? void 0 : _i.slideTo((_h = (_g = this.mainSwiper.swiperInstance) == null ? void 0 : _g.realIndex) != null ? _h : 0);
  }
  changeSlide(elm) {
    var _a, _b, _c;
    const index = (_b = (_a = this.slides) == null ? void 0 : _a.findIndex((slide) => slide.dataset.mediaId === elm.dataset.mediaId)) != null ? _b : 0;
    (_c = this.mainSwiper.swiperInstance) == null ? void 0 : _c.slideTo(index);
    this.updateBullets();
  }
  calculateVariantMedia(variantId) {
    var _a, _b;
    const variantMediaId = (_b = (_a = this.product) == null ? void 0 : _a.variants.find((v) => v.id === variantId).featured_media) == null ? void 0 : _b.id;
    const mediaIds = [];
    const allVariantMediaIds = this.calculateAllVariants();
    for (const media of this.product.media) {
      if (mediaIds.length > 0 && allVariantMediaIds.includes(media.id)) {
        break;
      }
      if (media.id === variantMediaId || mediaIds.length > 0) {
        mediaIds.push(media.id);
      }
    }
    return mediaIds;
  }
  calculateAllVariants() {
    const allVariantMediaIds = this.product.variants.map((v) => {
      var _a;
      return (_a = v.featured_media) == null ? void 0 : _a.id;
    }).filter((v) => v != null);
    return allVariantMediaIds;
  }
  updateVariantImage(_, evt) {
    var _a, _b, _c;
    const variantMedia = this.calculateVariantMedia(evt.detail.id);
    const bullet = (_a = this.bullets) == null ? void 0 : _a.find((bullet2) => {
      var _a2;
      return variantMedia.includes(parseInt((_a2 = bullet2.dataset.mediaId) != null ? _a2 : "0"));
    });
    (_c = this.mainSwiper.swiperInstance) == null ? void 0 : _c.slideTo(parseInt((_b = bullet == null ? void 0 : bullet.dataset.bullet) != null ? _b : "0"));
    this.updateBullets();
  }
};
__decorateClass([
  query("[data-main-swiper]")
], PbCommonProductSlider.prototype, "mainSwiper", 2);
__decorateClass([
  query("[data-thumbnail-swiper]")
], PbCommonProductSlider.prototype, "thumbnailSwiper", 2);
__decorateClass([
  queryAll("[data-bullet-img]")
], PbCommonProductSlider.prototype, "bulletImg", 2);
__decorateClass([
  queryAll("[data-bullet]")
], PbCommonProductSlider.prototype, "bullets", 2);
__decorateClass([
  queryAll("[data-gray-bullet]")
], PbCommonProductSlider.prototype, "grayBullets", 2);
__decorateClass([
  param("product")
], PbCommonProductSlider.prototype, "product", 2);
__decorateClass([
  liquidValue("product.selected_or_first_available_variant.id")
], PbCommonProductSlider.prototype, "initialVariantId", 2);
__decorateClass([
  queryAll("[data-media-id]")
], PbCommonProductSlider.prototype, "mediaImages", 2);
__decorateClass([
  query("[data-next]")
], PbCommonProductSlider.prototype, "nextBtn", 2);
__decorateClass([
  query("[data-prev]")
], PbCommonProductSlider.prototype, "prevBtn", 2);
__decorateClass([
  queryAll("[data-main-slide]")
], PbCommonProductSlider.prototype, "slides", 2);
__decorateClass([
  query("[data-main-wrapper]")
], PbCommonProductSlider.prototype, "wrapper", 2);
__decorateClass([
  globalOn("main:init")
], PbCommonProductSlider.prototype, "init", 1);
__decorateClass([
  onClick("[data-bullet]")
], PbCommonProductSlider.prototype, "changeSlide", 1);
__decorateClass([
  globalOn("product:variantChanged")
], PbCommonProductSlider.prototype, "updateVariantImage", 1);
PbCommonProductSlider = __decorateClass([
  defineElement("pb-common-product-slider")
], PbCommonProductSlider);
export {
  PbCommonProductSlider
};
